import type { FaireProductEntity } from "../../entity_types/product";

export const p_4trzwuj6qa: FaireProductEntity = {
  token: "p_4trzwuj6qa",
  type: "product",
  name: "Striped Plush Socks Women Winter Thick Cozy_CWMS02867",
  brandToken: "b_3eopd3scey",
  brandName: "ACCITY",
  imageUrl:
    "https://cdn.faire.com/fastly/dd6454e003b9893c90253d9041af87af5b8e7d5280f6457ce24a79e047b6be30.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d347e4b1560bca536f6ad2afad1e55885d68c3883ad38121ed55832a7539059f.jpeg",
    "https://cdn.faire.com/fastly/85110df28af3ab4e0e82e5c00fdf14f4de28c25d5e5f69fc87c46a5f72da67dc.jpeg",
    "https://cdn.faire.com/fastly/b7b231682681478fe7e045d0008208f3d52312cdac2b696e70d5b812be1244d6.jpeg",
    "https://cdn.faire.com/fastly/4169f3a5ecd58e8b1aa659a00fc77670111ccc37315681bedbfa12a44fef4ad7.jpeg",
    "https://cdn.faire.com/fastly/5e8f7f00adefd0c63b15ce4a5b3ca3a39dddd1eab1d816c7012a50ec9ddff2d0.jpeg",
    "https://cdn.faire.com/fastly/34ec7a3991e9a528c25198f1ecec9138bc371761e8cbb090b752f30a21ee38fb.jpeg",
    "https://cdn.faire.com/fastly/f9b4ddc9da975437daa85cddd8a7590a4b6696615fa67a317ff4878abaebde7f.jpeg",
    "https://cdn.faire.com/fastly/78d19acf741ea670ad0189ee8917407b59bba590f50ef513addb55fe8ad2676f.jpeg",
  ],
  priceDollars: 1.99,
  description:
    "• Material: 92% Polyester\n• Size: One Size Fits All\n\nTypes Of Products That Will Be On The Shelves During This Period:\nWomens Winter Socks,Thick Warm Crew Socks,Fluffy Cozy Socks For Women,Fuzzy Mid Calf Socks,Korean Style Socks,Fleece Lined Socks,Cute Heart Embroidery Socks,Soft Knit Socks For Fall,Daily Use Warm Socks,Neutral Color Socks,Trendy Girl Socks,Japanese Style Socks,Fashion Thermal Socks,Winter Home Socks,Chunky Ribbed Socks,Cold Weather Socks For Women,Sweet Bow Socks,Warm Lounge Socks,Stylish Cozy Socks,Casual Soft Socks,Cute Autumn Socks,Stretchy Fuzzy Socks,Fall Winter Sock Set,Comfort Cotton Socks,Indoor Outdoor Socks,Knitted Texture Socks,Plush Girly Socks.",
  tags: [],
  msrpDollars: 3.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:29.858Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
